export default {
      id: "soc-tw-usage",
      viewBox: "0 0 20 20",
      url: "/" + "assets/sprite.svg#soc-tw",
      toString: function () {
        return this.url;
      }
    }